import "./style.css";
import AnimButton from "../../components/animbutton";
import { Row } from "react-bootstrap";

export const RowContainer = ({ img, title, description, tools, link }) => {
    return (
        <>
            <div className="img_container col-lg-6" >
                <img src={img} alt="project" />
            </div>
            <div className="text_container col-lg-6 m-3 m-lg-0">
                <Row className="mx-2 my-4">
                    <h3>{title}</h3>
                </Row>
                <Row className="mx-2 text-justify">
                    <p>{description}</p>
                </Row>
                <Row className="tools mx-2">
                    {tools.map((data, index) => <p className="mx-2">{data}</p>)}
                </Row>
                <Row className="mx-2 my-4 d-flex">
                    {link.youtube && <a href={link.youtube}>
                        <AnimButton title="Video" />
                    </a>}
                    {link.github && <a href={link.github}>
                        <AnimButton title="Code" />
                    </a>}
                </Row>
            </div>
        </>
    )
}